
import { Component, Vue } from 'vue-property-decorator';
import appConfig from '@/config';
import { State } from 'vuex-class';
import { Roles } from '@/modules/authentication/models/rolesEnum';
import { checkRole } from '@/modules/authentication/helpers/checkRole';
import * as AuthService from '@/modules/authentication/services/authenticationService';

interface MenuItem {
  title: string;
  icon: string;
  routeName?: string;
  expand?: boolean;
  children?: MenuItem[];
}

@Component({
  components: {}
})
export default class NavBar extends Vue {
  @State((state) => state.authentication.decodedJwtToken)
  protected decodedJwtToken?: string;
  protected group = null;
  protected items: MenuItem[] = [];

  protected created(): void {
    this.items.push({ title: 'common.NavBar.homeLabel', icon: 'home', routeName: 'LandingPage' });
    if (checkRole(Roles.samples_update_state)) {
      this.items.push({ title: 'common.NavBar.barcodeLabel', icon: 'barcode', routeName: 'ReadBarcode' });
    }
    if (checkRole(Roles.requests_create)) {
      this.items.push({
        expand: false,
        title: 'common.NavBar.analysisLabel',
        icon: 'analysis',
        children: [
          { title: 'common.NavBar.newAnalysisLabel', icon: 'newAnalysis', routeName: 'NewAnalysis' },
          { title: 'common.NavBar.analysisDashboardLabel', icon: 'analysisDashboard', routeName: 'AnalysisDashboard' }
        ]
      });
    }
    if (checkRole(Roles.admin_edit_nomenclature)) {
      this.items.push({
        expand: false,
        title: 'common.NavBar.nomenclatureLabel',
        icon: 'nomenclature',
        children: [
          { title: 'common.NavBar.locationsLabel', icon: 'locations', routeName: 'Locations' },
          { title: 'common.NavBar.projectsLabel', icon: 'projects', routeName: 'Projects' }
        ]
      });
    }
    if (checkRole(Roles.results_upload)) {
      this.items.push({
        expand: false,
        title: 'common.NavBar.resultsLabel',
        icon: 'results',
        children: [{ title: 'common.NavBar.mergerLabel', icon: 'merger', routeName: 'Merger' }]
      });
    }
    if (checkRole(Roles.admin_edit_users)) {
      this.items.push({
        expand: false,
        title: 'common.NavBar.usersLabel',
        icon: 'users',
        routeName: 'Users'
      });
    }
    this.items.push({ title: 'common.NavBar.helpLabel', icon: 'help', routeName: 'Help' });
  }

  protected logout(): void {
    Vue.$cookies.remove(appConfig.security.jwtRefreshCookie);
    window.location.href = AuthService.buildLogoutLink();
  }
}
